import { UserDetailCtx } from "../contexts/UserDetailCtx";

export interface UserDetailType {
  id: number;
  unique_user_id: string;
  name: string;
  email: string | null;
  user_meta: user_meta
};

type user_meta = {
  profile_pic_url: null | string,
  user_role: null | string,
  video_feed_notification: null | boolean,
  audio_feed_notification: null | boolean,
  text_feed_notification: null | boolean,
  summary_email_notification: null | boolean
}

type userDetailSubscriberArgs = {
  userDetail: UserDetailType;
  isLoading: boolean;
  firstFetch: boolean;
};

type UserDetailSubscriber = (args: userDetailSubscriberArgs) => void;

export const userDetailStore = {
  userDetail: {} as UserDetailType,
  loading: false,
  firstFetch: false,

  subscribers: [] as UserDetailSubscriber[],

  // Add a subscriber
  subscribe(callback: UserDetailSubscriber) {
    this.subscribers.push(callback);
    return () => {
      this.unsubscribe(callback);
    };
  },

  // Remove a subscriber
  unsubscribe(callback: UserDetailSubscriber) {
    this.subscribers = this.subscribers.filter(sub => sub !== callback);
  },

  // Notify all subscribers
  notifySubscribers() {
    const args: userDetailSubscriberArgs = {
      userDetail: this.userDetail,
      isLoading: this.loading,
      firstFetch: this.firstFetch,
    };
    this.subscribers.forEach(callback => callback(args));
  },

  setUserDetail(newUserDetail: UserDetailType) {
    this.userDetail = newUserDetail;
    UserDetailCtx.setUserDetail(this.userDetail);
    this.loading = false;
    if (this.firstFetch === false) this.firstFetch = true;
    this.notifySubscribers();
  },

  setLoading(isLoading: boolean) {
    this.loading = isLoading;
    this.notifySubscribers();
  },

  clearAllUserDetail() {
    this.userDetail = {} as UserDetailType;
    this.loading = false;
    this.firstFetch = false;
  }
};